import { PaymentGateway } from '../../../../../services/exports/Constants';

export default {
  title: 'Haga clic en el botón de abajo para revisar y confirmar su información de pago.',
  payment_gateways: {
    [PaymentGateway.Stripe]: {
      description:
        'Trabajamos con Stripe para gestionar los pagos. Stripe es la plataforma de pago más segura utilizada por las mayores empresas del mundo.',
      form: {
        terms_acceptance: {
          label:
            'Al continuar, acepta nuestro <FoodAmigosTerms>Acuerdo de Servicios</FoodAmigosTerms> y el <StripeTerms>Acuerdo de Cuenta Conectada de Stripe.</StripeTerms>',
        },
      },
      labels: {
        stripe_requirements: 'Stripe todavía necesita los siguientes datos o no ha podido verificarlos:',
        errors: 'Errores',
        awaiting_verification: 'Tu cuenta de Stripe está siendo verificada',
        awaiting_verification_description:
          'Estamos esperando que Stripe termine de verificar tu negocio. Puedes revisar tu perfil mientras tanto.',
        details_hint:
          'Stripe comprueba los nombres, direcciones y números de teléfono con registros oficiales. Si alguno es incorrecto, corrígelo en Mi información → Información personal y Stripe lo volverá a comprobar. Todo lo demás que pida Stripe puedes añadirlo en tu perfil de Stripe.',
        requirements_hint:
          'Algunos de estos son documentos, como tu DNI: súbelos en el paso anterior, {{step}}, y luego vuelve aquí.',
        requirements_hint_profile: 'Algunos de estos son documentos, como tu DNI: súbelos en tu perfil de Stripe.',
      },
      requirements: {
        of_subject: '{{subject}}: {{detail}}',
        subjects: {
          owner: 'Propietario',
          representative: 'Representante',
          business: 'Empresa',
        },
        details: {
          first_name: 'Nombre',
          last_name: 'Apellido',
          email: 'Correo electrónico',
          phone: 'Número de teléfono',
          dob: 'Fecha de nacimiento',
          id_number: 'Número de identificación',
          nationality: 'Nacionalidad',
          address: 'Calle y número',
          city: 'Ciudad',
          postal_code: 'Código postal',
          state: 'Provincia',
          country: 'País',
          id_document: 'Documento de identidad',
          proof_of_address: 'Comprobante de domicilio',
          job_title: 'Cargo',
          business_name: 'Razón social',
          tax_id: 'Número de identificación fiscal',
          vat_id: 'Número de IVA',
          registration_number: 'Número de registro',
          website: 'Sitio web',
          industry: 'Sector',
          product_description: 'Descripción de lo que vendes',
          support_phone: 'Teléfono de atención al cliente',
          owners: 'Confirmación de los propietarios',
          directors: 'Confirmación de los directores',
          executives: 'Confirmación de los ejecutivos',
          registration_document: 'Documento de registro de la empresa',
          bank_account: 'Cuenta bancaria para pagos',
          business_type: 'Tipo de empresa',
          terms: 'Aceptación de los términos de Stripe',
          bank_account_proof: 'Comprobante de titularidad de la cuenta bancaria',
          tax_id_document: 'Documento del número de identificación fiscal',
        },
      },
    },
    [PaymentGateway.Adyen]: {
      description:
        'Trabajamos con Adyen para gestionar los pagos. Adyen es una de las plataformas de pago más seguras, utilizada por las mayores empresas del mundo.',
    },
  },
  labels: {
    verified: 'Tu cuenta de {{paymentGateway}} está verificada',
    verified_description:
      'La verificación de {{paymentGateway}} está completa. Aún puedes gestionar tu perfil si lo necesitas.',
  },
  buttons: {
    proceed: 'Confirmar mi información de pago',
    copy_link: 'Copiar enlace',
    back: 'Atrás',
  },
  toasts: {
    something_went_wrong: 'Algo salió mal, contacta con el soporte técnico',
  },
};
